export default __webpack_public_path__ + "static/media/decoration_v1.cd96ffda.svg";